import React, { useEffect, useState } from 'react';
import { Tabs, TabList, Tab, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { RiEdit2Line, RiDeleteBin6Line } from 'react-icons/ri';
import Modal from '../../modals/Modal';
import PermitForm from './PermitForm';
import MailOwner from './MailOwner';
import MailProvider from './MailProvider';
import { useAppContext } from '../../context/AppContext';
import axios from 'axios';
import { Delete, Edit } from 'lucide-react';
import { toast } from 'react-toastify';
import Products from '../products/Products'
import { StyledButton } from '../../Shared';

const Permits = () => {
  const [permitHolders, setPermitHolders] = useState([]);
  const [mailProviders, setMailProviders] = useState([]);
  const [mailOwners, setMailOwners] = useState([]);
  const [modalOpen, setModalOpen] = useState(null);
  const [editIndex, setEditIndex] = useState(null);
  const [editType, setEditType] = useState(null);
  const [permits, setPermits] = useState([]);
  const [owners, setOwners] = useState([]);
  const [providers, setProviders] = useState([]);
  const { user, axiUrl } = useAppContext();
  const [reset, setReset] = useState(true);
  const [permit, setPermit] = useState(null);
  const [provider, setProvider] = useState(null);
  const [editPermitItemId, setEditPermitItemId] = useState(null);
  const [permitOpen, setPermitOpen] = useState(false);
  const [ownerOpen, setOwnerOpen] = useState(false);
  const [providerOpen, setProviderOpen] = useState(false);
  const [editOwnerItemId, setEditOwnerItemId] = useState(null);
  const [owner, setOwner] = useState(null);
  const [editProviderItemId, seteditProviderItemId] = useState(null);

  console.log(editProviderItemId);

  useEffect(() => {
    const getperms = async () => {
      await axios
        .post(`${axiUrl}/permits/getpermitholder`, { id: user.company?._id })
        .then((res) => setPermits(res.data));
    };
    const getowners = async () => {
      await axios
        .post(`${axiUrl}/permits/getmailowners`, { id: user.company?._id })
        .then((res) => setOwners(res.data));
    };
    const getproviders = async () => {
      await axios
        .post(`${axiUrl}/permits/getmailproviders`, { id: user.company?._id })
        .then((res) => {
          console.log(res.data);
          setMailProviders(res.data);
        });
    };
    getproviders();
    getperms();
    getowners();
  }, [reset]);

  useEffect(() => {
    const check = async () => {
      if (permitOpen === false) {
        await setPermit(null);
        setEditPermitItemId(null);
        await setPermitOpen(false);
      }
      if (ownerOpen === false) {
        await setOwner(null);
        setEditOwnerItemId(null);
        await setOwnerOpen(false);
      }
      if (providerOpen === false) {
        await setProvider(null);
        seteditProviderItemId(null);
        await setProviderOpen(false);
      }
    };
    check();
  }, [permitOpen, ownerOpen, providerOpen]);



  const generateId = () => Math.random().toString(36).substr(2, 9);

  const openModal = (type, index = null) => {
    setModalOpen(type);
    setEditIndex(index);
    setEditType(type);
  };

  const closeModal = () => {
    setModalOpen(null);
    setEditIndex(null);
    setEditType(null);
  };

  const handleDelete = async (type, item) => {
    if (window.confirm('Are you sure you want to delete this entry?')) {
      if (type === 'permitHolder') {
        await axios
          .post(`${axiUrl}/permits/removepermit`, { id: item._id })
          .then((res) => {
            toast.success(res.data.message);
            setReset(!reset);
          })
          .catch((err) => console.log(err));
      } else if (type === 'mailProvider') {
        await axios
          .post(`${axiUrl}/permits/removeprovider`, { id: item._id })
          .then((res) => {
            toast.success(res.data.message);
            setReset(!reset);
          })
          .catch((err) => console.log(err));
      } else if (type === 'mailOwner') {
        await axios
          .post(`${axiUrl}/permits/removeowner`, { id: item._id })
          .then((res) => {
            toast.success(res.data.message);
            setReset(!reset);
          })
          .catch((err) => console.log(err));
      }
      console.log(`${type} Entry Deleted at index ${item.name}`);
    }
  };

  const formatAddress = (item) => (
    <div>
      {item.address}
      <br />
      {item.address2 && (
        <>
          {item.address2}
          <br />
        </>
      )}
      {item.city}, {item.state}, {item.zip}
    </div>
  );

  const handlePermitEdit = (item) => {
    setEditPermitItemId(item._id);
    setPermit({
      permitName: item.permitName || '',
      companyName: item.companyName || '',
      address: item.address || '',
      address2: item.address2 || '',
      city: item.city || '',
      state: item.state || '',
      zip: item.zip || '',
      isDefault: item.isDefault || false,
      permitType: item.permitType || 'Stamp',
      permitNumber: item.permitNumber || '',
      dueNetNumber: item.dueNetNumber || '',
      accountNumber: item.accountNumber || '',
      bmeu: item.bmeu || '',
      company: user.company?._id
    });
    setPermitOpen(true);
  };

  const handleOwnerEdit = (item) => {
    console.log(item);
    setEditOwnerItemId(item._id);
    setOwner({
      id: item._id,
      template: item.template,
      companyName: item.companyName,
      address: item.address,
      address2: item.address2,
      city: item.city,
      state: item.state,
      zip: item.zip,
      crid: item.crid,
      mid: item.mid,
      nonprofitnumber: item.nonprofitnumber,
      anywhere: item.anywhere,
      company: user.company?._id
    });
    setOwnerOpen(true);
  };

  const handleProviderEdit = (item) => {
    seteditProviderItemId(item._id);
    setProvider({
      id: item._id,
      providerName: item.providerName,
      name: item.name,
      address: item.address,
      address2: item.address2,
      city: item.city,
      state: item.state,
      zip: item.zip,
      telephone: item.telephone,
      crid: item.crid,
      mid: item.mid,
      repname: item.repname,
      repphone: item.repphone,
      repemail: item.repemail,
      einduction: item.einduction,
      seamless: item.seamless,
      company: user.company?._id
    });
    setProviderOpen(true);
  };

  return (
    <div className='relative w-full px-[30px]'>
      <Modal
        show={permitOpen}
        onClose={() => setPermitOpen(false)}
        // header="My Modal"
        // width="50%"
        // contentBgColor="#f9f9f9"
        // headerTextAlign="center"
        // headerBgColor="#007bff"
        // headerColor="white"
      >
        <PermitForm
          permit={permit || null}
          setPermit={setPermit}
          editPermitItemId={editPermitItemId}
          setReset={setReset}
          reset={reset}
          onClose={() => setPermitOpen(false)}
        />
      </Modal>
      <Modal
        show={ownerOpen}
        onClose={() => setOwnerOpen(false)}
        // header="My Modal"
        // width="50%"
        // contentBgColor="#f9f9f9"
        // headerTextAlign="center"
        // headerBgColor="#007bff"
        // headerColor="white"
      >
        <MailOwner
          owner={owner || null}
          editOwnerItemId={editOwnerItemId}
          setPermit={setPermit}
          setReset={setReset}
          reset={reset}
          onClose={() => setOwnerOpen(false)}
        />
      </Modal>
      <Modal
        show={providerOpen}
        onClose={() => setProviderOpen(false)}
        // header="My Modal"
        // width="50%"
        // contentBgColor="#f9f9f9"
        // headerTextAlign="center"
        // headerBgColor="#007bff"
        // headerColor="white"
      >
        <MailProvider
          provider={provider || null}
          editProviderItemId={editProviderItemId}
          setProvider={setProvider}
          setReset={setReset}
          reset={reset}
          onClose={() => setProviderOpen(false)}
        />
      </Modal>
      <div className="w-full p-2 text-3lg">
        <h1 className="text-3lg font-bold text-gray-800 mb-2">Permit and mailer information</h1>
        <Tabs className=''>
          <TabList className="flex ">
            <Tab >Permit Holders</Tab>
            <Tab>Mail Providers</Tab>
            <Tab>Mail Owners</Tab>
              <Tab>Campaign Templates</Tab>
          </TabList>
          <TabPanel>
            <div className="bg-white shadow-md rounded-lg overflow-hidden mt-[20px] ">
              <div className="space-y-2">
                <StyledButton size="small"  onClick={() => setPermitOpen(true)}>New Permit Setup</StyledButton>
                {permits.length === 0 ? (
                  <p className="text-sm">No permit holders added.</p>
                ) : (
                  <div className="bg-white shadow-md rounded-lg overflow-hidden">
                    <table className="min-w-full divide-y divide-gray-200">
                      <thead className="bg-gray-50">
                        <tr className="">
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider max-w-xs"></th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider max-w-xs">
                            Name
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider max-w-xs">
                            Company
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider max-w-xs">
                            Number
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider max-w-xs">
                            Type
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider max-w-xs">
                            Account
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider max-w-xs">
                            Net Due #
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider max-w-xs">
                            BMEU
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider max-w-xs"></th>
                        </tr>
                      </thead>
                      <tbody className="bg-white divide-y divide-gray-200">
                        {permits.map((permit) => (
                          <tr key={permit.id} className=" hover:bg-gray-50 dark:hover:bg-gray-700">
                            <td className="px-6 py-4 text-sm text-gray-900 max-w-xs truncate">
                              {permit.isDefault ? 'Default' : ''}
                            </td>
                            <td className="px-6 py-4 text-sm text-gray-900 max-w-xs truncate">{permit.permitName}</td>
                            <td className="px-6 py-4 text-sm text-gray-900 max-w-xs truncate">{permit.companyName}</td>
                            <td className="px-6 py-4 text-sm text-gray-900 max-w-xs truncate">{permit.permitNumber}</td>
                            <td className="px-6 py-4 text-sm text-gray-900 max-w-xs truncate">{permit.permitType}</td>
                            <td className="px-6 py-4 text-sm text-gray-900 max-w-xs truncate">{permit.accountNumber}</td>
                            <td className="px-6 py-4 text-sm text-gray-900 max-w-xs truncate">{permit.dueNetNumber}</td>
                            <td className="px-6 py-4 text-sm text-gray-900 max-w-xs truncate">{permit.bmeu}</td>
                            <td className="flex-1 px-6 py-4 whitespace-nowrap text-sm text-gray-900 flex space-x-2">
                              <Edit
                                color="rgba(0,0,255,0.5)"
                                size={18}
                                onClick={() => handlePermitEdit(permit)}
                                className="cursor-pointer"
                              />
                              <Delete
                                color="rgba(255,0,0,0.5)"
                                size={18}
                                onClick={() => handleDelete('permitHolder', permit)}
                                className="cursor-pointer"
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
          </TabPanel>

          <TabPanel>
            <div className="bg-white shadow-md rounded-lg overflow-hidden mt-[20px] ">
              <div className="space-y-2">

                   <StyledButton size="small"  onClick={() => setProviderOpen(true)}>New Mail Provider</StyledButton>
          
                {mailProviders.length === 0 ? (
                  <p className="text-sm">No mail providers added.</p>
                ) : (
                  <div className="bg-white shadow-md rounded-lg overflow-hidden">
                    <table className="min-w-full divide-y divide-gray-200">
                      <thead className="bg-gray-50">
                        <tr>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider max-w-xs">
                            Name
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider max-w-2xl">
                            Mailing Agent Crid
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider max-w-xs">
                            Mailing Agent Crid
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider max-w-xs">
                            Represenative
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider max-w-xs">
                            Rep Phone
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Rep Email
                          </th>
                        </tr>
                      </thead>
                      <tbody className="bg-white divide-y divide-gray-200">
                        {mailProviders.map((item, index) => (
                          <tr key={item.id}>
                            <td className="px-6 py-4 text-sm text-gray-900 max-w-xs truncate">{item.name}</td>
                            <td className="px-6 py-4 text-sm text-gray-900 max-w-2xl">{item.crid}</td>
                            <td className="px-6 py-4 text-sm text-gray-900 max-w-xs truncate">{item.mid || 'N/A'}</td>
                            <td className="px-6 py-4 text-sm text-gray-900 max-w-xs truncate">{item.repname || 'N/A'}</td>
                            <td className="px-6 py-4 text-sm text-gray-900 max-w-xs truncate">{item.repphone || 'N/A'}</td>
                            <td className="px-6 py-4 text-sm text-gray-900 max-w-xs truncate">{item.repemail || 'N/A'}</td>
                            <td className="px-6 py-4 text-sm text-gray-900 flex space-x-2">
                              <RiEdit2Line
                                color="rgba(0,0,255,0.5)"
                                size={18}
                                onClick={() => handleProviderEdit(item)}
                                className="cursor-pointer"
                              />
                              <RiDeleteBin6Line
                                color="rgba(255,0,0,0.5)"
                                size={18}
                                onClick={() => handleDelete('mailProvider', item)}
                                className="cursor-pointer"
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
          </TabPanel>

          <TabPanel>
            <div className="bg-white shadow-md rounded-lg overflow-hidden mt-[20px]">
              <div className="space-y-2">
                 <StyledButton size="small"    onClick={() => setOwnerOpen(true)}> New Mail Owner</StyledButton>
             
                {owners.length === 0 ? (
                  <p className="text-sm">No mail owners added.</p>
                ) : (
                  <div className="bg-white shadow-md rounded-lg overflow-hidden">
                    <table className="min-w-full divide-y divide-gray-200">
                      <thead className="bg-gray-50 w-full">
                        <tr className="flex">
                          <th className="flex-1 px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider max-w-xs">
                            Template
                          </th>
                          <th className="flex-1 px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider max-w-xs">
                            Name
                          </th>
                          {/* <th className="flex-2 px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider max-w-2xl">Address</th> */}
                          <th className="flex-1 px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider max-w-xs">
                            Non Profit Auth #
                          </th>
                          <th className="flex-1 px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider max-w-xs">
                            CRID
                          </th>
                          <th className="flex-1 px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider max-w-xs">
                            MID
                          </th>
                          <th className="flex-1 px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider max-w-xs">
                            Anywhere Account #
                          </th>
                          <th className="flex-1 px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"></th>
                        </tr>
                      </thead>
                      <tbody className="bg-white divide-y divide-gray-200">
                        {owners.map((item, index) => (
                          <tr key={item.id} className="flex">
                            <td className="flex-1 px-6 py-4 text-sm text-gray-900 max-w-xs truncate">{item.template}</td>
                            <td className="flex-1 px-6 py-4 text-sm text-gray-900 max-w-xs truncate">{item.companyName}</td>
                            {/* <td className="flex-2 px-6 py-4 text-sm text-gray-900 max-w-2xl truncate">{formatAddress(item)}</td> */}
                            <td className="flex-1 px-6 py-4 text-sm text-gray-900 max-w-xs truncate">
                              {item.nonprofitnumber || 'N/A'}
                            </td>
                            <td className="flex-1 px-6 py-4 text-sm text-gray-900 max-w-xs truncate">{item.crid || 'N/A'}</td>
                            <td className="flex-1 px-6 py-4 text-sm text-gray-900 max-w-xs truncate">{item.mid || 'N/A'}</td>
                            <td className="flex-1 px-6 py-4 text-sm text-gray-900 max-w-xs truncate">{item.anywhere || 'N/A'}</td>
                            <td className="flex-1 px-6 py-4 text-sm text-gray-900 flex space-x-2">
                              <RiEdit2Line
                                color="rgba(0,0,255,0.5)"
                                size={18}
                                onClick={() => handleOwnerEdit(item)}
                                className="cursor-pointer"
                              />
                              <RiDeleteBin6Line
                                color="rgba(255,0,0,0.5)"
                                size={18}
                                onClick={() => handleDelete('mailOwner', item)}
                                className="cursor-pointer"
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
          </TabPanel>
          <TabPanel>
            <div className="bg-white shadow-md rounded-lg overflow-hidden mt-[20px] ">
              <div className="space-y-2">
                {/* <StyledButton size="small"  onClick={() => setPermitOpen(true)}>New Permit Setup</StyledButton> */}
                {permits.length === 0 ? (
                  <p className="text-sm">No permit holders added.</p>
                ) : (
                  <div className="bg-white shadow-md rounded-lg overflow-hidden">
                    <table className="min-w-full divide-y divide-gray-200">
                      <thead className="bg-gray-50">
                        <tr className="">
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider max-w-xs"></th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider max-w-xs">
                            Name
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider max-w-xs">
                            Company
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider max-w-xs">
                            Number
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider max-w-xs">
                            Type
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider max-w-xs">
                            Account
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider max-w-xs">
                            Net Due #
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider max-w-xs">
                            BMEU
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider max-w-xs"></th>
                        </tr>
                      </thead>
                      <tbody className="bg-white divide-y divide-gray-200">
                        {permits.map((permit) => (
                          <tr key={permit.id} className=" hover:bg-gray-50 dark:hover:bg-gray-700">
                            <td className="px-6 py-4 text-sm text-gray-900 max-w-xs truncate">
                              {permit.isDefault ? 'Default' : ''}
                            </td>
                            <td className="px-6 py-4 text-sm text-gray-900 max-w-xs truncate">{permit.permitName}</td>
                            <td className="px-6 py-4 text-sm text-gray-900 max-w-xs truncate">{permit.companyName}</td>
                            <td className="px-6 py-4 text-sm text-gray-900 max-w-xs truncate">{permit.permitNumber}</td>
                            <td className="px-6 py-4 text-sm text-gray-900 max-w-xs truncate">{permit.permitType}</td>
                            <td className="px-6 py-4 text-sm text-gray-900 max-w-xs truncate">{permit.accountNumber}</td>
                            <td className="px-6 py-4 text-sm text-gray-900 max-w-xs truncate">{permit.dueNetNumber}</td>
                            <td className="px-6 py-4 text-sm text-gray-900 max-w-xs truncate">{permit.bmeu}</td>
                            <td className="flex-1 px-6 py-4 whitespace-nowrap text-sm text-gray-900 flex space-x-2">
                              <Edit
                                color="rgba(0,0,255,0.5)"
                                size={18}
                                onClick={() => handlePermitEdit(permit)}
                                className="cursor-pointer"
                              />
                              <Delete
                                color="rgba(255,0,0,0.5)"
                                size={18}
                                onClick={() => handleDelete('permitHolder', permit)}
                                className="cursor-pointer"
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
          </TabPanel>
        </Tabs>
      </div>
    </div>
  );
};

export default Permits;